module.exports = __webpack_public_path__ + "img/ztd_empty.6ed14624.png";